import { render, staticRenderFns } from "./QuestionsTemplateWidget.vue?vue&type=template&id=9f095768&scoped=true"
import script from "./QuestionsTemplateWidget.vue?vue&type=script&lang=js"
export * from "./QuestionsTemplateWidget.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTemplateWidget.vue?vue&type=style&index=0&id=9f095768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f095768",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSkeletonLoader,VSwitch,VTextField,VTooltip})
